.RGContainer
    position: relative
    width: 100%
    height: 100%
    .RGImages
        position: relative
        min-width: 0
        width: 100%
        height: 100%
        display: flex
        flex-direction: row
        overflow: auto
        scroll-snap-type: x mandatory
        box-sizing: border-box
        scrollbar-width: none
        &::-webkit-scrollbar
            display: none
        .RGImage
            flex-shrink: 0
            scroll-snap-align: start
            img
                width: 100%
                height: 100%
                object-fit: cover

    .RGCNav
        position: absolute
        bottom: 10px
        left: 50%
        transform: translateX(-50%)
        display: flex
        align-items: center
        gap: 6px
        transition: transform 0s
        .RGCIndicator
            width: 10px
            height: 10px
            border-radius: 50%
            background: #e6e6e6
            opacity: 0.5
            cursor: pointer
            border: 1px solid #D0D0D6
            &:hover
                opacity: 0.7
            &:active
                opacity: 0.8
        .RGCIndicatorSelected
            background: #ccc
            opacity: 1
            cursor: default
            box-shadow: 0 0 0 1px #fff
            &:hover
                opacity: 1
            &:active
                opacity: 1

    .RGCNavRight, .RGCNavLeft
        top: 50%
        cursor: pointer
        transform-origin: center
        transform: translateY(-50%)
        stroke: #D0D0D6
        opacity: 1
        &:hover
            opacity: 0.8
        &:active
            opacity: 0.6

    .RGCNavDisabled
        opacity: 0
        pointer-events: none

    .RGCNavRight
        position: absolute
        right: 10px

    .RGCNavLeft
        position: absolute
        left: 10px
